export default class BackLogisticsList {
    userCode: string;
    warehouseName: string;
    orderNumber: number;
    createTime: Date;
    id: number;
    IncurredAmount: number;
    Channel: number;
    Balance: number;
    storeName: string;
    site: number;
}